<div class="h-[70px]">
    <div *transloco="let t"
        [class]="'pl-2 pr-4 mx-auto w-[385px] rounded-full border-black items-center h-[51px] flex bg-white bg-opacity-25 backdrop-blur-[50px] ' + customClass"
        [ngClass]="{'!bg-red-700 !bg-opacity-100 !blur-0': last}">

        <div class="text-white font-bold text-[30px] pl-2 w-[65px] h-[40px] border-r-white border-r-2 text-center flex items-center"
            [ngClass]="{'!text-[22px]': position > 99 && position < 1000,'!text-[16px]': position >= 1000 && position < 10000,'!text-[12px]': position >= 10000}">
            {{position}}°
        </div>
        <div class="flex gap-2 px-2 items-center border-r-white border-r-2 h-[40px]">
            <div class="text-[30px]">{{icon}}</div>
            <div class="text-white font-bold text-[24px] w-[165px] overflow-hidden text-ellipsis">{{nickname}}</div>
        </div>
        <div class="text-white font-bold text-[18px] pl-2" [ngClass]="{'!text-[14px]': score > 999||score < -999,'!text-[12px]': score > 999999 || score <-999999}">
            {{score}}</div>
    </div>
</div>